import { PhoneVerificationFormSchema } from 'commons/auditionForm';
import { useTranslationWithLang } from 'hooks/useTranslationWithLang';

// 多言語対応のためスキーマをフック化
export const usePhoneVerificationSchema = () => {
  const { t } = useTranslationWithLang('auditionForm');

  const schema = PhoneVerificationFormSchema({
    RequiredMessage: t('Validate_Required'),
    PhoneNumberMessage: t('Validate_PhoneNumber'),
    FullWidthMessage: t('Validate_FullWidth'),
  });
  return schema;
};
